import React from 'react'
import { FionaProducts } from 'parameters/general'
import { BasicCrossSell } from 'components/content/CrossSell/Basic'
import { buildDashItem } from 'experiences/dashboard/DashboardRoot/lib/types'

const lifeInsuranceItem = buildDashItem(
	<BasicCrossSell product={FionaProducts.LifeInsurance} isVertical isButtonBlock />,
	'none'
)

const savingsItem = buildDashItem(<BasicCrossSell product={FionaProducts.Savings} isVertical isButtonBlock />, 'none')
const creditCardsItem = buildDashItem(
	<BasicCrossSell product={FionaProducts.CreditCards} isVertical isButtonBlock />,
	'none'
)

const loansItem = buildDashItem(<BasicCrossSell product={FionaProducts.Loans} isVertical isButtonBlock />, 'none')

export const CrossSellItems = {
	savingsItem,
	lifeInsuranceItem,
	creditCardsItem,
	loansItem
}
